import { useState, useRef, useEffect } from 'react';
// images
import Logo from '../assets/logo.svg';
import { Link } from 'react-scroll';
// React Icons
import { GiMusicalNotes } from 'react-icons/gi';
import { MdMusicOff } from 'react-icons/md';

const Header = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.play().catch(error => {
        console.error('Error playing audio on mount:', error);
      });
    }
  }, []);

  const handleMusicToggle = () => {
    if (isPlaying) {
      audioRef.current.pause();
      console.log('Audio paused');
    } else {
      audioRef.current.play().catch(error => {
        console.error('Error playing audio on click:', error);
      });
      console.log('Audio playing');
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <header className='py-8'>
      <div className='container mx-auto'>
        <div className='flex justify-between items-center'>
          {/* Logo */}
          <Link to='about'>
            <img style={{ cursor: "pointer" }} src={Logo} alt='' />
          </Link>
          {/* Music Icon */}
          <div onClick={handleMusicToggle} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
            {isPlaying ? (
              <GiMusicalNotes
                size={30}
                style={{ marginRight: '8px' }}
                className='text-accent'
              />
            ) : (
              <MdMusicOff
                size={30}
                style={{ marginRight: '8px' }}
              />
            )}
          </div>
          {/* Audio element */}
          <audio ref={audioRef} src='/assets/Midnight.mp3' loop />
          {/* button */}
          <a href='mailto:priscildu49@hotmail.fr'>
            <button className='btn btn-sm'>Me Contacter</button>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
